import Swiper, { Navigation, Pagination, Lazy } from "swiper";
Swiper.use([Pagination, Navigation, Lazy]);

const initDissmisalriskSlider = () => {
  const slider = document.querySelector(".riskDiss__content");

  slider &&
    new Swiper(slider, {
      autoHeight: true,
      loop: false,
      lazy: true,
      spaceBetween: 20,
      slidesPerView: 1,
      navigation: {
        nextEl: ".riskDiss__navigation-next",
        prevEl: ".riskDiss__navigation-prev",
        disabledClass: "last",
      },
      pagination: {
        el: ".riskDiss__pagination",
        type: "fraction",
      },
    });
};

export default initDissmisalriskSlider;
